<script setup lang="ts">
import { useI18n } from "vue-i18n";
defineProps<{ subject: string; sender: string }>();
const { t } = useI18n();
</script>

<template>
  <dl>
    <div class="mb-4 border-b border-slate-100 pb-4">
      <dt class="text-sm font-medium text-slate-500">{{ t("subject") }}</dt>
      <dd class="line-clamp-2 break-words font-medium" :title="subject">{{ subject }}</dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-slate-500">{{ t("sender") }}</dt>
      <dd class="break-words font-medium">{{ sender }}</dd>
    </div>
  </dl>
</template>
